import type SessionService from '@efdigital/ll-addon-auth/services/session';
import type { CoachProfile } from '@efdigital/ll-addon-data';
import type CoachService from '@efdigital/ll-xceed-v2/services/coach';
import type CoachActionRequiredService from '@efdigital/ll-xceed-v2/services/coach-action-required';
import type PartnershipMessagingService from '@efdigital/ll-xceed-v2/services/partnership-messaging';
import { syncCoachPartnershipMessaging } from '@efdigital/ll-xceed-v2/utils/coaching/sync-partnership-messaging';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

export interface CoachingCoachModel {
  coach: CoachProfile;
}

export default class CoachingCoachRoute extends Route<CoachingCoachModel> {
  @service declare coach: CoachService;
  @service declare coachActionRequired: CoachActionRequiredService;
  @service declare partnershipMessaging: PartnershipMessagingService;
  @service declare session: SessionService;
  @service declare store: Store;

  async model(): Promise<CoachingCoachModel> {
    const coach = await this.coach.getPublishedProfile();
    return {
      coach,
    };
  }

  async afterModel(): Promise<void> {
    const coachUserId = this.session.cached.userId!;

    // Both feed nav badges, and neither blocks the other.
    await Promise.all([
      syncCoachPartnershipMessaging(
        this.store,
        this.coach,
        coachUserId,
        this.partnershipMessaging
      ),
      this.coachActionRequired.sync(this.store, coachUserId),
    ]);
  }
}
